export default "__VITE_ASSET__BlhFgBNZ__"